import React, { useState, useEffect } from 'react';

const itTestimonialsData = [
  {
    id: 1,
    quote:
      'Experts Communication completely transformed our cloud infrastructure and automated our deployment pipelines on AWS. Our deployment speeds increased by 400% with zero downtime. Outstanding IT expertise!',
    author: 'Marcus Sterling',
    designation: 'CTO, CloudMatrix Systems',
    avatar: '/assets/images/team_member_1.png'
  },
  {
    id: 2,
    quote:
      'Their 24/7 managed IT support and cybersecurity team detected and prevented critical threats before they could disrupt our operations. They act as a seamless extension of our internal engineering team.',
    author: 'Elena Rostova',
    designation: 'Head of Infrastructure, Apex Global Tech',
    avatar: '/assets/images/team_member_2.png'
  },
  {
    id: 3,
    quote:
      'Finding a top-tier IT company in Pakistan capable of building scalable enterprise architectures and custom software was a game changer for us. Their engineering excellence and modern tools set them apart.',
    author: 'Kamran Siddiqui',
    designation: 'Director of Engineering, FinTech Pioneer',
    avatar: '/assets/images/team_member_3.png'
  },
  {
    id: 4,
    quote:
      'From database clustering to microservices migration, Experts Communication delivered our multi-cloud roadmap ahead of schedule with 99.99% system availability. Truly world-class IT consultancy.',
    author: 'David Henderson',
    designation: 'VP of Technology, Omnichannel Global',
    avatar: '/assets/images/hr-manager.jpg'
  }
];

function ItServicesTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide smoothly every 4.5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % itTestimonialsData.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('it-services-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const currentTestimonial = itTestimonialsData[currentIndex];

  return (
    <section className="ecom-testimonial-section">
      <div className="container bpo-testimonial-container">
        {/* Left Column: Headings, Sliding Card, and Button */}
        <div className="bpo-testimonial-left">
          <span className="bpo-testimonial-tag">
            What clients say about our IT services!
          </span>

          <h2 className="bpo-testimonial-title">
            Delivering Robust IT Solutions That <span className="text-red">Empower Enterprises</span>
          </h2>

          <p className="bpo-testimonial-desc">
            Discover authentic feedback and success stories from CTOs, IT leaders, and global business founders whose infrastructure, cloud systems, and data operations are powered by Experts Communication.
          </p>

          {/* Testimonial Card */}
          <div className="bpo-testimonial-card-wrapper">
            <div className="bpo-testimonial-card" key={currentTestimonial.id}>
              {/* Star Rating */}
              <div className="bpo-stars-row">
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
              </div>

              {/* Review Quote Text */}
              <p className="bpo-quote-text">
                "{currentTestimonial.quote}"
              </p>

              {/* Client Info & Quotation Icon */}
              <div className="bpo-client-row">
                <div className="bpo-client-info">
                  <img 
                    src={currentTestimonial.avatar} 
                    alt={currentTestimonial.author} 
                    className="bpo-client-avatar"
                  />
                  <div className="bpo-client-details">
                    <h4 className="bpo-client-name">{currentTestimonial.author}</h4>
                    <span className="bpo-client-role">{currentTestimonial.designation}</span>
                  </div>
                </div>

                {/* Quotation Symbol */}
                <div className="bpo-quote-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2H4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2h-4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button className="btn-bpo-explore" onClick={handleDiscussClick}>
            Let's Discuss Your IT Infrastructure
          </button>
        </div>

        {/* Right Column: 5-Star Reviews Showcase Graphic */}
        <div className="bpo-testimonial-right">
          <div className="bpo-reviews-img-wrapper">
            <img 
              src="/assets/images/bpo_reviews_neon.jpg" 
              alt="5-Star IT Services Client Reviews Showcase" 
              className="bpo-reviews-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ItServicesTestimonialsSlider;
